import { useTranslation } from "react-i18next";
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const EventSuccess = () => {
      const { t } = useTranslation();
    return (
            <div
      style={{
        backgroundColor: "#f5f7ff",
        height: "60vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "10px",
          padding: "40px 80px",
          textAlign: "center",
          boxShadow: "0 0 5px rgba(0,0,0,0.05)",
        }}
      >
       <DotLottieReact
           src="https://lottie.host/fd12d912-0cd6-4a6e-b1fc-99ca9ddcd8d4/1pj83eJmSE.lottie"
           loop
           autoplay
           speed={0.5}
     />

        <p
         className='mb-2 font-15 fw-6 green-color'
        >
          {t("messageText.eventBookedSuccessfully") ||
            "Event Booked Successfully"}
        </p>

        <p
        className='font-12 gray'
        >
          {t("messageText.yourEventHasBeenBookedSuccessfully") ||
            "Your event has been booked successfully."}
        </p>
      </div>
    </div>
    )
}


export default EventSuccess;

